import { AxiosResponse } from "axios";
import { build } from "search-params";

import $http from "./instance";

interface GetProductsParams {
	offset?: number;
	limit?: number;
}

class ProductsClient {
	public static async getProducts(
		params: GetProductsParams = {}
	): Promise<AxiosResponse> {
		const { offset, limit } = params;

		const query = build({
			offset: offset || 0,
			limit: limit || 1000,
		});

		return $http.get(`/products?${query}`);
	}

	public static async getProductById(id: string): Promise<AxiosResponse> {
		return $http.get(`/products/${id}`);
	}
}

export default ProductsClient;
